import * as R from "ramda";

import { createHandlers } from "redux-mvc";

import { NAMESPACE } from "Portal/NewPortal/FollowupForm/constants";

const iniState = {
  submissionId: null,
  returnTo: null,
  impersonateContactId: null,
  impersonateAccountId: null,
  closeAt: null,
  allowEdits: true,
  isClosed: false,
  isSubmitted: false,
  loading: false,
  saving: false,
  searching: false,
  error: null,
  activeIndex: 2,
  formData: {},
  termsAccepted: false,
  groupValues: {},
  contactValues: {},
  intakeId: "",
  isLoggedIn: false,
  loggedInLabel: null,
  previewing: false,
  emailError: "",
  eventTimezone: null,
  eventEnableUniqueContacts: false,
  isSessionForm: false,
  sessionTitle: null,
  markCompletedAsViewOnly: false,
  eventName: null,
  eventSlug: null,
  styles: {},
  cssCode: null,
  accentColor: null,
  backgroundImageUrl: null,
  logoImageUrl: null,
  verifyingEmail: false,
  currentContactEmail: null
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    nextPage: R.identity,
    backPage: R.identity,
    goToLoginPage: R.identity,
    saveValues: R.identity,
    handleLogout: R.identity,
    checkUser: R.identity,
    onCreateAccount: R.identity,
    verifyEmail: R.identity,
    goToPortalHome: R.identity,
    seedFormData: (
      state,
      {
        payload: {
          submissionId,
          userEmail,
          formPayload,
          isLoggedIn,
          loggedInLabel,
          contactValues,
          eventName,
          eventSlug,
          styles,
          cssCode,
          accentColor,
          backgroundImageUrl,
          logoImageUrl,
          currentContactEmail
        }
      }
    ) => {
      return {
        markCompletedAsViewOnly: formPayload.mark_completed_as_view_only,
        isSubmitted: formPayload.is_submitted,
        eventEnableUniqueContacts: formPayload.event_enable_unique_contacts,
        eventTimezone: formPayload.event_timezone,
        submissionId,
        activeIndex: 2,
        previewing: !submissionId,
        userEmail: userEmail ? userEmail.toLowerCase().trim() : userEmail,
        formData: formPayload,
        closeAt: formPayload.close_at,
        allowEdits: formPayload.allow_edits,
        isClosed: formPayload.is_closed,
        isLoggedIn,
        loggedInLabel,
        contactValues: contactValues
          ? contactValues
          : formPayload.selected_contact_values || {},
        isSessionForm: formPayload?.is_session_form,
        sessionTitle: formPayload?.session_title,
        eventName,
        eventSlug,
        styles,
        cssCode,
        accentColor,
        backgroundImageUrl,
        logoImageUrl,
        currentContactEmail
      };
    },
    updateContactValues: (state, { payload: { id, value } }) => ({
      contactValues: R.assoc(id, value, state.contactValues)
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
